// ─── Feuille : créer / éditer un ingrédient du référentiel ────────
// Entité simple (nom + unité + rayon) — pas de fiche lecture seule séparée,
// comme les comptes bancaires de My Finance.
import React, { useEffect, useMemo, useState } from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, ChoixPuces, stylesForm, useUI, useT } from '@mop/core';

const VIDE = { nom: '', unite: '', categorie: '' };
const UNITES = ['g', 'kg', 'mL', 'cl', 'L', 'pièce', 'botte', 'sachet', 'boîte'];

export default function FeuilleIngredient({ visible, initial, rayons = [], onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => StyleSheet.create({ ...stylesForm(UI) }), [UI]);
  const [f, setF] = useState(VIDE);

  useEffect(() => { if (visible) setF({ ...VIDE, ...(initial || {}) }); }, [visible, initial]);

  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const valide = !!(f.nom || '').trim();

  return (
    <Feuille visible={visible} titre={initial?.id ? t('ingredients.modifier') : t('ingredients.nouveau')}
      emoji="🥕" hauteur={0.6} onFermer={onFermer}
      action={{ icone: initial?.id ? '💾' : '＋', label: t('commun.enregistrer'), disabled: !valide, onPress: () => onEnregistrer(f) }}>

      <Text style={s.lbl}>{t('commun.nom')}</Text>
      <TextInput style={s.input} value={f.nom} onChangeText={v => set('nom', v)}
        placeholder={t('ingredients.phNom')} placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('repas.unite')}</Text>
      <ChoixPuces options={UNITES.map(u => ({ id: u, label: u }))} value={f.unite} onChange={v => set('unite', v)} />

      <Text style={s.lbl}>{t('ingredients.rayon')}</Text>
      <ChoixPuces options={rayons.map(r => ({ id: r.id, label: `${r.emoji} ${r.label}` }))}
        value={f.categorie} onChange={v => set('categorie', v)} />
    </Feuille>
  );
}
